import {
  askResponseSchema,
  queryExecuteResponseSchema,
  type AskResponse,
  type QueryExecuteResponse,
  type QuerySpec,
} from '@console/types'
import { apiPost } from '../api.js'
import { fetchCsrfToken } from '../auth/api.js'

/** Classify a question. Runs nothing — see `executeQuery` for the second, separate step. */
export async function askQuestion(prompt: string): Promise<AskResponse> {
  const csrfToken = await fetchCsrfToken()
  return apiPost('/ask', { prompt }, csrfToken, askResponseSchema)
}

/**
 * Run a classified query. A distinct call from `askQuestion` on purpose: it is
 * what makes "the operator always confirms before running" true of the wire,
 * not just of the UI.
 */
export async function executeQuery(spec: QuerySpec): Promise<QueryExecuteResponse> {
  const csrfToken = await fetchCsrfToken()
  return apiPost('/ask/execute', spec, csrfToken, queryExecuteResponseSchema)
}
